var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1378,
    height: 247,
    viewBox: "0 0 1378 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1100 6.73792H928.72V66.3679H1055.2L918.21 203.358L960.95 246.108L1100 107.058V239.048H1159.63V66.3679V6.73792H1100Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.99 238.738V6.40784H349.82V238.738H291.99Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.03 6.73792V239.038H888.34V6.73792H656.03ZM830.03 180.738H714.35V65.048H830.02L830.03 180.738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.54 6.3678L0 6.29797V239.048H57.84V193.488H233.54V6.3678ZM175.22 135.168H58.33V64.7379H175.22V135.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.97 239.048H626.16V179.408H466.97V6.73792H407.33V179.408V239.048H466.97Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318.12 6.73792H1259.11H1200.1V65.7479H1259.11H1318.12H1377.13V6.73792H1318.12Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1377.13,
    height: 245.74,
    fill: "white",
    transform: "translate(0 0.36792)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8d92897e7f9fbb2ad411214cf71e8933.svg";
export { ForwardRef as ReactComponent };